import { AuthConfig } from 'angular-oauth2-oidc';
import { environment } from 'src/environments/environment';

export class AuthConstants {
    public static get authConfig(): AuthConfig {
        const config = {
            // Url of the Identity Provider
            issuer: environment.issuer_url,

            // URL of the SPA to redirect the user to after login
            redirectUri: !environment.production
                ? window.location.origin
                : window.location.origin + '/merlin-cloud/base',

            // The SPA's id. The SPA is registered with this id at the auth-server
            clientId: environment.client_id,
            showDebugInformation: true,
            // set the scope for the permissions the client should request
            // The first three are defined by OIDC. The 4th is a usecase-specific one
            // scope: 'openid ebce2d28-8fb8-4cc7-83ae-accc9d73ee9d',
            scope: environment.scope,

            strictDiscoveryDocumentValidation: false,

            postLogoutRedirectUri: !environment.production
                ? window.location.origin
                : window.location.origin + '/merlin-cloud/base',

            logoutUrl: !environment.production
                ? window.location.origin
                : window.location.origin + '/merlin-cloud/base',
        };
        //console.log(config);
        return config;
    }
    public static get d2Url(): string {
        // return environment.discovery_url;
        return null;
    }
    public static get changePasswordD2Url(): string {
        // return environment.changePasswordD2Url;
        return null;
    }
    public static get loginMFA(): string {
        // return environment.loginMFA;
        return null;
    }
}
